import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  Url: string;
  constructor(public http: HttpClient) {
      this.Url = GlobalConstants.apiURL;;
  }

  public async ConsultaClientes(Nombre: string,email:string) {
    let params = new HttpParams().set("Nombre", Nombre).set("email",email);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return await lastValueFrom(this.http.get(this.Url + '/getCliente',{params}));
  }


  public async DatosEntregaCliente(Id: string) {
    
    let params = new HttpParams().set("IdCliente", Id);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return await lastValueFrom(this.http.get(this.Url + '/getDatosEntregaCliente',{params}));
  }

  
  public insertCliente(DatosCli:any) {
    let json = JSON.stringify(DatosCli);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return lastValueFrom(this.http.post(this.Url + '/addCliente', params, { headers: headers }));
}
public  addUppDatosEntregaCliente(DatosCli:any) {
  let json = JSON.stringify(DatosCli);
  let params = json;
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  return lastValueFrom(this.http.post(this.Url + '/addUppDirEntregas', params, { headers: headers }));
}
  public UpdateCliente(DatosCli:any) {
    let json = JSON.stringify(DatosCli);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return lastValueFrom(this.http.post(this.Url + '/uppCliente', params, { headers: headers }));

  }
}
